import React from "react";
import { Dark } from "../../Theme/Theme";
import "./ConfirmModal.css";

export default function ConfirmModal({ text = "Are you sure you want to proceed", yes, no }) {
  return (
    <div className="ConfirmModal" role="dialog" aria-modal="true" aria-labelledby="confirm-modal-title">
      <div className="ConfirmMain" id="confirm-modal-title">
        {text}
      </div>
      <div className="ConfirmCild">
        <button
          onClick={no}
          style={{ backgroundColor: Dark.sell, marginRight: 20 }}
          className="btnlogout"
          aria-label="Cancel"
        >
          No
        </button>

        <button
          onClick={yes}
          style={{ backgroundColor: Dark.buy }}
          className="btnlogout"
          aria-label="Confirm"
        >
          Yes
        </button>
      </div>
    </div>
  );
}
